<template>
  <div class="job-list">
    <h3>职位管理</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="职位id">
        <el-input v-model="filter.jobId" placeholder="职位id"></el-input>
      </el-form-item>
      <el-form-item label="职位名称">
        <el-input v-model="filter.jobTitle" placeholder="职位名称"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="filter.phoneNumber" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="甲方昵称">
        <el-input v-model="filter.partyAName" placeholder="甲方昵称"></el-input>
      </el-form-item>
      <el-form-item label="人才类型">
        <el-select v-model="filter.jobCate">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in firstCates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位状态">
        <el-select v-model="filter.status">
          <el-option label="全部" value=""></el-option>
          <el-option label="关闭" :value="0"></el-option>
          <el-option label="开启" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有工作">
        <el-select v-model="filter.workNum">
          <el-option label="全部职位" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位级别">
        <el-input
          type="number"
          min="1"
          v-model="filter.jobLevel"
          placeholder="职位级别"
        ></el-input>
      </el-form-item>
      <el-form-item label="跟进人">
        <el-input
          type="text"
          v-model="filter.lastFollower"
          placeholder="跟进人"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否健康">
        <el-select v-model="filter.isHealth">
          <el-option label="全部职位" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间从">
        <el-date-picker
          v-model="filter.createTimeStart"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.createTimeEnd"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="exportExcel" size="mini"
            >导出</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="jobId" label="职位编号"></el-table-column>
      <el-table-column prop="title" label="职位名称">
        <template slot-scope="scope">
          <a
            :href="`${frontUrl}/job/detail/${scope.row.jobId}`"
            target="_blank"
            >{{ scope.row.title }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="publisherName" label="雇主昵称">
        <template slot-scope="scope"
          ><a :href="`/clients?uid=${scope.row.publisherId}`" target="_blank">{{
            scope.row.publisherName
          }}</a></template
        >
      </el-table-column>
      <el-table-column
        prop="publisherTel"
        label="雇主联系方式"
      ></el-table-column>
      <el-table-column prop="jobCateName" label="行业类别"></el-table-column>
      <el-table-column prop="" label="预算">
        <template slot-scope="scope">
          <template v-if="scope.row.chargingWay">{{
            scope.row.projectPrice
          }}</template>
          <template v-else>{{ scope.row.monthlyRate }}/月</template>
        </template>
      </el-table-column>
      <el-table-column prop="quoteNum" label="投递数量">
        <template slot-scope="scope">
          <a :href="`/quotes?jid=${scope.row.jobId}`" target="_blank">{{
            scope.row.quoteNum
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="workNum" label="工作数量">
        <template slot-scope="scope">
          <a :href="`/orders?jid=${scope.row.jobId}`" target="_blank">{{
            scope.row.workNum
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="maxImNum" label="最大沟通数量"></el-table-column>
      <el-table-column prop="status" label="职位状态">
        <template slot-scope="scope">{{
          map.job.status[scope.row.status]
        }}</template>
      </el-table-column>
      <el-table-column prop="readNum" label="浏览量"></el-table-column>
      <el-table-column prop="publishTime" label="发布时间"></el-table-column>
      <el-table-column prop="clientType" label="客户分类">
        <template slot-scope="scope">{{
          map.client.type[scope.row.clientType]
        }}</template>
      </el-table-column>
      <el-table-column prop="lastFollower" label="跟进人"></el-table-column>
      <el-table-column label="操作" flex="right">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="!scope.row.status"
                :command="{ action: 'pushMatch', data: scope.row }"
                >推送给服务商</el-dropdown-item
              >
              <el-dropdown-item
                v-if="!scope.row.isPush"
                :command="{ action: 'pushHot', data: scope.row }"
                >推送至热门</el-dropdown-item
              >
              <el-dropdown-item
                v-else
                :command="{ action: 'pushHot', data: scope.row }"
                >取消热门</el-dropdown-item
              >
              <el-dropdown-item command="">
                <a :href="`/job/${scope.row.jobId}`" target="_blank">修改</a>
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a
                  :href="`/sessions?senderId=${scope.row.publisherId}&entityId=${scope.row.jobId}`"
                  target="_blank"
                  >查看沟通记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a :href="`/follows?jobId=${scope.row.id}`" target="_blank"
                  >查看跟进记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a
                  :href="`/follow/detail?userId=${scope.row.publisherId}&jobId=${scope.row.jobId}&from=jobs`"
                  target="_blank"
                  >添加跟进记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a :href="`/matchs?jobId=${scope.row.jobId}`" target="_blank"
                  >查看匹配记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item
                :command="{ action: 'switchJob', data: scope.row }"
              >
                {{ map.job.status[Number(!scope.row.status)] }}职位
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog title="输入用户ID" :visible.sync="pushDialogShow">
      <el-form>
        <el-form-item>
          <p>
            多个用户id使用“#”分割；确定推送后，给用户发送系统通知（如果已经投递，就不发送）
          </p>
          <p>职位包含的对照标签：{{ tags.join(",") }}</p>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="例如：111#222#333"
            v-model="pushUserId"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <ul class="push-records" v-if="pushRecords.length">
        <li v-for="(record, index) in pushRecords" :key="index">
          {{ record.pushTime }} 完成匹配，推送人数 {{ record.count }} 【{{
            map.match.type[record.pushRule]
          }}】
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="matchAgain">{{
          isMatching ? "匹配中" : "系统匹配"
        }}</el-button>
        <el-button @click="pushDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="pushMsg">推 送</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="curJob.status ? '选择关闭原因' : '开启职位'"
      class="dialog-switch"
      :visible.sync="dialog.switchJob"
    >
      <el-form v-if="curJob.status">
        <el-form-item>
          <el-radio-group v-model="closeReason">
            <el-radio
              v-for="reason in closeReasons"
              :key="reason.id"
              :label="reason.id"
              >{{ reason.reason }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <p v-else>确定要重新开启职位吗？</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="toggleDialog('switchJob')">取 消</el-button>
        <el-button type="primary" @click="switchJobFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { job, common, workCateList } = api;

export default {
  name: "job-list",
  data() {
    return {
      map,
      loading: true,
      list: [],
      limit: 20,
      pageNum: 1,
      total: 0,
      filter: {
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        jobTitle: this.$route.query.jobTitle,
        jobId: "",
        workNum: 0,
        partyAName: "",
        phoneNumber: "",
        jobLevel: "",
        jobCate: "",
        lastFollower: "",
        isHealth: 0,
      },
      statusMap: {},
      pushDialogShow: false,
      pushUserId: "",
      pushData: {
        needsId: "",
        userIds: [],
      },
      pushIng: false,
      dialogPayChannel: false,
      curOrder: null,
      dialog: {
        switchJob: false,
      },
      closeReasons: [],
      closeReason: "",
      curJob: {},
      pushRecords: [],
      tags: [],
      isMatching: false,
      cates: [],
    };
  },
  components: {},
  computed: {
    nickUserName() {
      return location.search;
    },
    payChannel() {
      return map.payChannel;
    },
    publisherId() {
      return this.$route.query.publisherId;
    },
    firstCates() {
      return this.getCatesById(0);
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  create() {
    // this.filter.jobId = this.$route.query.jobId;
  },
  methods: {
    toggleDialog(name, data = {}) {
      this.dialog[name] = !this.dialog[name];
      this.curJob = data;
      this.closeReason = "";
    },
    async getAllTags() {
      let {
        data: { code, data },
      } = await workCateList.getAllTags();
      if (code == 200) {
        this.cates = data.workCategory;
      }
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          arr.push(item);
        }
      });
      return arr;
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let {
        status,
        createTimeStart,
        createTimeEnd,
        jobTitle,
        jobId,
        workNum,
        partyAName,
        phoneNumber,
        jobLevel,
        jobCate,
        lastFollower,
        isHealth,
      } = this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        publisherId: this.publisherId,
        createTimeStart,
        createTimeEnd,
        status,
        jobTitle,
        jobId,
        workNum,
        partyAName,
        phoneNumber,
        jobLevel,
        jobCate,
        lastFollower,
        isHealth,
      };

      let res = await job.list(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },

    async exportExcel() {
      this.loading = true;
      let resp = await job.export();
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("职位列表.xls");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
    showPushDialog(data) {
      this.pushDialogShow = !this.pushDialogShow;
      this.pushData.jobId = data.jobId;
      this.pushUserId = "";
      this.getPushRecords();
    },
    async getPushRecords() {
      let obj = {
        jobId: this.pushData.jobId,
      };
      let {
        data: { code, data },
      } = await job.pushRecords(obj);
      if (code == 200) {
        this.pushRecords = data.freelancerLogs;
        this.tags = data.tags;
      }
    },
    async pushMsg() {
      let arr = this.pushUserId.split("#");
      this.pushData.userIds = [];
      arr.forEach((item) => {
        if (item) {
          this.pushData.userIds.push(item);
        }
      });
      if (this.pushData.userIds.length > 0) {
        this.pushIng = true;
        let res = await job.push(this.pushData);
        if (res.data.code == 200) {
          this.$message.success("推送中");
          this.pushDialogShow = false;
        }
        this.pushIng = false;
      } else {
        this.$message.error("请输入正确的用户ID");
      }
    },
    async showIndex(needsId, isShow) {
      let res = "";
      if (isShow) {
        res = await job.showIndex({
          needsId: needsId,
        });
      } else {
        res = await job.cancelShowIndex({
          needsId: needsId,
        });
      }
      if (res.data.code == 200) {
        let msg = isShow ? "已推送到首页" : "已取消首页展示";
        this.$message.success(msg);
        this.fetch(2);
      }
    },
    async showHot(jobId) {
      const res = await job.showHot({
        jobId: jobId,
      });
      if (res.data.code == 200) {
        this.$message.success("操作成功");
        this.fetch(2);
      }
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "pushMatch":
          this.showPushDialog(data);
          break;
        case "pushHot":
          this.showHot(data.jobId);
          break;
        case "switchJob":
          this.toggleDialog("switchJob", data);
          break;
        default:
      }
    },
    async getCloseReasons() {
      let res = await common.getReasons({ type: 2 });
      if (res.data.code == 200) {
        this.closeReasons = res.data.data;
      }
    },
    async switchJobFn() {
      let obj = {
        jobId: this.curJob.jobId,
      };
      if (this.curJob.status) {
        if (!this.closeReason) {
          this.$message.error("请选择关闭原因");
          return false;
        } else {
          obj.closeReasonId = this.closeReason;
        }
      }
      let {
        data: { code, data },
      } = await job.switch(obj);
      if (code == 200) {
        this.$message.success("操作成功");
        this.fetch(2);
      } else {
        this.$message.error("操作失败");
      }
      this.toggleDialog("switchJob");
    },
    async matchAgain() {
      this.isMatching = true;
      let obj = {
        jobId: this.pushData.jobId,
      };
      let res = await job.matchAgain(obj);
      if (res.data.code == 200) {
        this.getPushRecords();
        this.$message.success("匹配完成");
      }
      this.isMatching = false;
    },
  },
  mounted() {
    this.getAllTags();
    this.fetch();
    this.getCloseReasons();
  },
};
</script>
<style>
.dialog-switch .el-radio {
  display: block;
}
.dialog-switch .el-radio + .el-radio {
  margin: 10px 0 0;
}
.push-records {
  list-style: none;
}
</style>


// WEBPACK FOOTER //
// src/views/job/jobs.vue